import { getString } from "../../common/common";

export const HEADING1_1 = "HEADING1_1";
export const HEADING1_2 = "HEADING1_2";
export const HEADING2 = "HEADING2";
export const HEADING3 = "HEADING3";
export const DIRECTOR = "DIRECTOR";
export const OFFICIAL = "OFFICIAL";

export const CENTRAL_GOV_REP = "CENTRAL_GOV_REP";
export const NON_OFFICIAL = "NON_OFFICIAL";
export const INVITEE = "INVITEE";

export const NAME1_L1 = "NAME1_L1";
export const NAME1_L2 = "NAME1_L2";
export const NAME1_L3 = "NAME1_L3";
export const NAME1_L4 = "NAME1_L4";
export const NAME1_L5 = "NAME1_L5";

export const NAME2_L1 = "NAME2_L1";
export const NAME2_L2 = "NAME2_L2";
export const NAME2_L3 = "NAME2_L3";
export const NAME2_L4 = "NAME2_L4";

export const NAME3_L1 = "NAME3_L1";
export const NAME3_L2 = "NAME3_L2";
export const NAME3_L3 = "NAME3_L3";
export const NAME3_L4 = "NAME3_L4";

export const NAME4_L1 = "NAME4_L1";
export const NAME4_L2 = "NAME4_L2";
export const NAME4_L3 = "NAME4_L3";
export const NAME4_L4 = "NAME4_L4";

export const NAME5_L1 = "NAME5_L1";
export const NAME5_L2 = "NAME5_L2";
export const NAME5_L3 = "NAME5_L3";

export const NAME6_L1 = "NAME6_L1";
export const NAME6_L2 = "NAME6_L2";
export const NAME6_L3 = "NAME5_L3";

export const NAME7_L1 = "NAME7_L1";
export const NAME7_L2 = "NAME7_L2";
export const NAME7_L3 = "NAME7_L3";

export const NAME8_L1 = "NAME8_L1";
export const NAME8_L2 = "NAME8_L2";
export const NAME8_L3 = "NAME8_L3";

export const NAME9_L1 = "NAME9_L1";
export const NAME9_L2 = "NAME9_L2";
export const NAME9_L3 = "NAME9_L3";

export const NAME10_L1 = "NAME10_L1";
export const NAME10_L2 = "NAME10_L2";
export const NAME10_L3 = "NAME10_L3";

export const NAME11_L1 = "NAME11_L1";
export const NAME11_L2 = "NAME11_L2";
export const NAME11_L3 = "NAME11_L3";
export const NAME11_L4 = "NAME11_L4";

export const NAME12_L1 = "NAME12_L1";
export const NAME12_L2 = "NAME12_L2";
export const NAME12_L3 = "NAME12_L3";
export const NAME12_L4 = "NAME12_L4";

export const NAME13_L1 = "NAME13_L1";
export const NAME13_L2 = "NAME13_L2";
export const NAME13_L3 = "NAME13_L3";

export const NAME14_L1 = "NAME14_L1";
export const NAME14_L2 = "NAME14_L2";
export const NAME14_L3 = "NAME14_L3";
export const NAME14_L4 = "NAME14_L4";

export const NAME15_L1 = "NAME15_L1";
export const NAME15_L2 = "NAME15_L2";
export const NAME15_L3 = "NAME15_L3";
export const NAME15_L4 = "NAME15_L4";

export const translations = {
  en: {
    [HEADING1_1]: "Updated Information is published on ksrtc.karnataka.gov.in",
    [HEADING1_2]: "to View",
    [HEADING2]: "Management",
    [HEADING3]: "The Board of Directors of KSRTC as on 10-12-2020.",

    [DIRECTOR]: "DIRECTOR",
    [OFFICIAL]: "(Official)",
    [CENTRAL_GOV_REP]: "(Central Govt. Representative)",
    [NON_OFFICIAL]: "(Non - Official)",
    [INVITEE]: "INVITEE",

    [NAME1_L1]: "SRI. M CHANDRAPPA,",
    [NAME1_L2]: "Hon'ble M.L.A and Chairman,",
    [NAME1_L3]: "KSRTC, Central Office,",
    [NAME1_L4]: "Bangalore-560 027",
    [NAME1_L5]: "HON'BLE CHAIRMAN",

    [NAME2_L1]: "SRI. S. N. ESHWARAPPA",
    [NAME2_L2]: "Vice Chairman, KSRTC, Central Office",
    [NAME2_L3]: "Bangalore-560 027",
    [NAME2_L4]: "HON'BLE VICE CHAIRMAN",

    [NAME3_L1]: "SRI. I.S.N. PRASAD, IAS",
    [NAME3_L2]: "Additional Chief Secretary to Government,",
    [NAME3_L3]: "Finance Dept., Government of Karnataka,",
    [NAME3_L4]: "Vidhana Soudha, Bangalore-560 001",

    [NAME4_L1]: "SRI. ANJUM PARWEZ, IAS",
    [NAME4_L2]: "Principal Secretary to Government,",
    [NAME4_L3]: "Transport Department., Govt. of Karnataka,",
    [NAME4_L4]: "M.S.Buildings, Bangalore-560 001",

    [NAME5_L1]: "SRI.SHIVAYOGI C KALASAD, IAS",
    [NAME5_L2]: "Managing Director, KSRTC,",
    [NAME5_L3]: "Central Offices, Bangalore - 560 027.",

    [NAME6_L1]: "SMT. C.SHIKHA, IAS",
    [NAME6_L2]: "Managing Director, BMTC, Central Office,",
    [NAME6_L3]: "Bangalore -560 027",

    [NAME7_L1]: "SRI KRISHNA BAJPAI, IAS",
    [NAME7_L2]: "Managing Director, NWKRTC, Central Office,",
    [NAME7_L3]: "HUBLI.",

    [NAME8_L1]: "SRI. KURMA RAO M, IAS",
    [NAME8_L2]: "Managing Director, NEKRTC, Central Office,",
    [NAME8_L3]: "Kalburgi..",

    [NAME9_L1]: "Dr. RAM NIWAS SEPAT, IPS",
    [NAME9_L2]: "Director (Security & Vigilance), KSRTC, Central Office,",
    [NAME9_L3]: "Bangalore -560 027",

    [NAME10_L1]: "SRI, VENKATESH. T, KAS",
    [NAME10_L2]: "Director (Personnel & Environment), KSRTC, Central Office,",
    [NAME10_L3]: "Bangalore -560 027",

    [NAME11_L1]: "SRI. PARESH KUMAR GOEL",
    [NAME11_L2]: "Director(Transport), Ministry of Road Transport & Highways,",
    [NAME11_L3]:
      "Transport Bhavan, No.1, Parliament Street, Government of India,",
    [NAME11_L4]: "New Delhi 110 001.",

    [NAME12_L1]: "SRI. P. RUDRESH",
    [NAME12_L2]: "Bus Owner, Shree Veerabhadreshwara Nilaya,",
    [NAME12_L3]: "Opp Govt., Primary School, 3rd Cross, Venkatesha Nagara,",
    [NAME12_L4]: "Shivamogga 577 201.",

    [NAME13_L1]: "SRI. RAJU VITTALASA JARATARAGHARA",
    [NAME13_L2]: "Divati Oni, Sidda Veerappana Peth,",
    [NAME13_L3]: "Near Kamari Peth Police Station, Huballi 580 028.",

    [NAME14_L1]: "SRI. AARUNDI NAGARAJA",
    [NAME14_L2]: "No 180, Behind Ganesha Temple,",
    [NAME14_L3]: "Near Old Bus Station, Ward Number 17,",
    [NAME14_L4]: "Hosapet Road, Bellary.",

    [NAME15_L1]: "Sri. Girish C. Hosur, IFS",
    [NAME15_L2]: "Metropolitan Commissioner BMRDA,",
    [NAME15_L3]: "Govt.of Karnataka, No.1, Ali Asker Road,",
    [NAME15_L4]: "Bangalore-560001.",
  },
  kn: {
    [HEADING1_1]:
      "ಅಪ್‌ಡೇಟ್ ಮಾಡಿದ ಮಾಹಿತಿಯನ್ನು ksrtc.karnataka.gov.in ನಲ್ಲಿ ಪ್ರಕಟಿಸಲಾಗಿದೆ ವೀಕ್ಷಿಸಲು",
    [HEADING1_2]: "",
    [HEADING2]: "ನಿರ್ವಹಣೆ",
    [HEADING3]: "10-12-2020 ರಂತೆ KSRTC ಯ ನಿರ್ದೇಶಕರ ಮಂಡಳಿ.",

    [DIRECTOR]: "ನಿರ್ದೇಶಕ",
    [OFFICIAL]: "(ಅಧಿಕೃತ)",
    [CENTRAL_GOV_REP]: "(ಕೇಂದ್ರ ಸರ್ಕಾರದ ಪ್ರತಿನಿಧಿ)",
    [NON_OFFICIAL]: "(ಅಧಿಕೃತವಲ್ಲದ)",
    [INVITEE]: "ಆಹ್ವಾನಿತರು",

    [NAME1_L1]: "ಶ್ರೀ. ಎಂ ಚಂದ್ರಪ್ಪ,",
    [NAME1_L2]: "ಮಾನ್ಯ M.L.A ಮತ್ತು ಅಧ್ಯಕ್ಷರು,",
    [NAME1_L3]: "ಕೆಎಸ್‌ಆರ್‌ಟಿಸಿ, ಕೇಂದ್ರ ಕಚೇರಿ,",
    [NAME1_L4]: "ಬೆಂಗಳೂರು-560 027",
    [NAME1_L5]: "ಗೌರವಾನ್ವಿತ ಅಧ್ಯಕ್ಷರು",

    [NAME2_L1]: "ಶ್ರೀ. ಎಸ್.ಎನ್.ಈಶ್ವರಪ್ಪ,",
    [NAME2_L2]: "ಉಪಾಧ್ಯಕ್ಷರು, KSRTC, ಕೇಂದ್ರ ಕಛೇರಿ,",
    [NAME2_L3]: "ಬೆಂಗಳೂರು-560 027",
    [NAME2_L4]: "ಗೌರವಾನ್ವಿತ ಉಪಾಧ್ಯಕ್ಷರು",

    [NAME3_L1]: "ಶ್ರೀ. I.S.N. ಪ್ರಸಾದ್, IAS",
    [NAME3_L2]: "ಸರ್ಕಾರದ ಹೆಚ್ಚುವರಿ ಮುಖ್ಯ ಕಾರ್ಯದರ್ಶಿ,",
    [NAME3_L3]: "ಹಣಕಾಸು ಇಲಾಖೆ, ಕರ್ನಾಟಕ ಸರ್ಕಾರ,",
    [NAME3_L4]: "ವಿಧಾನಸೌಧ, ಬೆಂಗಳೂರು-560 001",

    [NAME4_L1]: "ಶ್ರೀ. ಅಂಜುಮ್ ಪರ್ವೇಜ್, IAS",
    [NAME4_L2]: "ಸರ್ಕಾರದ ಪ್ರಧಾನ ಕಾರ್ಯದರ್ಶಿ,",
    [NAME4_L3]: "ಸಾರಿಗೆ ಇಲಾಖೆ, ಸರ್ಕಾರ ಕರ್ನಾಟಕದ,",
    [NAME4_L4]: "ಎಂ.ಎಸ್.ಕಟ್ಟಡಗಳು, ಬೆಂಗಳೂರು-560 001",

    [NAME5_L1]: "ಶ್ರೀ.ಶಿವಯೋಗಿ ಸಿ ಕಲಸದ್, IAS",
    [NAME5_L2]: "ವ್ಯವಸ್ಥಾಪಕ ನಿರ್ದೇಶಕರು, KSRTC,",
    [NAME5_L3]: "ಕೇಂದ್ರ ಕಚೇರಿಗಳು, ಬೆಂಗಳೂರು - 560 027.",

    [NAME6_L1]: "SMT. ಸಿ.ಶಿಖಾ, IAS",
    [NAME6_L2]: "ವ್ಯವಸ್ಥಾಪಕ ನಿರ್ದೇಶಕರು, BMTC, ಕೇಂದ್ರ ಕಛೇರಿ,",
    [NAME6_L3]: "ಬೆಂಗಳೂರು -560 027",

    [NAME7_L1]: "ಶ್ರೀ ಕೃಷ್ಣ ಬಾಜಪೇಯಿ, IAS",
    [NAME7_L2]: "ವ್ಯವಸ್ಥಾಪಕ ನಿರ್ದೇಶಕರು, NWKRTC, ಕೇಂದ್ರ ಕಚೇರಿ,",
    [NAME7_L3]: "ಹುಬ್ಬಳ್ಳಿ.",

    [NAME8_L1]: "ಶ್ರೀ. ಕುರ್ಮಾ ರಾವ್ ಎಂ, IAS",
    [NAME8_L2]: "ವ್ಯವಸ್ಥಾಪಕ ನಿರ್ದೇಶಕರು, NEKRTC, ಕೇಂದ್ರ ಕಛೇರಿ,",
    [NAME8_L3]: "ಕಲಬುರ್ಗಿ..",

    [NAME9_L1]: "ಡಾ. ರಾಮ್ ನಿವಾಸ್ ಸೆಪಟ್, IAS",
    [NAME9_L2]: "ನಿರ್ದೇಶಕರು (ಭದ್ರತೆ ಮತ್ತು ವಿಜಿಲೆನ್ಸ್), KSRTC, ಕೇಂದ್ರ ಕಚೇರಿ,",
    [NAME9_L3]: "ಬೆಂಗಳೂರು -560 027",

    [NAME10_L1]: "ಶ್ರೀ, ವೆಂಕಟೇಶ್. ಟಿ, KAS",
    [NAME10_L2]: "ನಿರ್ದೇಶಕರು (ಸಿಬ್ಬಂದಿ ಮತ್ತು ಪರಿಸರ), KSRTC, ಕೇಂದ್ರ ಕಚೇರಿ,",
    [NAME10_L3]: "ಬೆಂಗಳೂರು -560 027",

    [NAME11_L1]: "ಶ್ರೀ. ಪರೇಶ್ ಕುಮಾರ್ ಗೋಯಲ್",
    [NAME11_L2]: "ನಿರ್ದೇಶಕರು (ಸಾರಿಗೆ), ರಸ್ತೆ ಸಾರಿಗೆ ಮತ್ತು ಹೆದ್ದಾರಿಗಳ ಸಚಿವಾಲಯ,",
    [NAME11_L3]: "ಸಾರಿಗೆ ಭವನ, ನಂ.1, ಪಾರ್ಲಿಮೆಂಟ್ ಸ್ಟ್ರೀಟ್, ಭಾರತ ಸರ್ಕಾರ,",
    [NAME11_L4]: "ನವದೆಹಲಿ 110 001.",

    [NAME12_L1]: "ಶ್ರೀ. ಪಿ.ರುದ್ರೇಶ್",
    [NAME12_L2]: "ಬಸ್ ಮಾಲೀಕರು, ಶ್ರೀ ವೀರಭದ್ರೇಶ್ವರ ನಿಲಯ,",
    [NAME12_L3]: "ಸರ್ಕಾರಿ ಎದುರು, ಪ್ರಾಥಮಿಕ ಶಾಲೆ, 3ನೇ ಕ್ರಾಸ್, ವೆಂಕಟೇಶ ನಗರ,",
    [NAME12_L4]: "ಶಿವಮೊಗ್ಗ 577 201.",

    [NAME13_L1]: "ಶ್ರೀ. ರಾಜು ವಿಟ್ಟಲಸ ಜರತರಾಘರಾ",
    [NAME13_L2]: "ದೀವಟಿ ಓಣಿ, ಸಿದ್ದ ವೀರಪ್ಪನ ಪೇಠ,",
    [NAME13_L3]: "ಕಮರಿ ಪೇಠ ಪೊಲೀಸ್ ಠಾಣೆ ಹತ್ತಿರ, ಹುಬ್ಬಳ್ಳಿ 580 028.",

    [NAME14_L1]: "ಶ್ರೀ. ಆರುಂಡಿ ನಾಗರಾಜ",
    [NAME14_L2]: "ಸಂಖ್ಯೆ 180, ಗಣೇಶ ದೇವಸ್ಥಾನದ ಹಿಂದೆ,",
    [NAME14_L3]: "ಹಳೆಯ ಬಸ್ ನಿಲ್ದಾಣದ ಹತ್ತಿರ, ವಾರ್ಡ್ ಸಂಖ್ಯೆ 17,",
    [NAME14_L4]: "ಹೊಸಪೇಟೆ ರಸ್ತೆ, ಬಳ್ಳಾರಿ",

    [NAME15_L1]: "ಶ್ರೀ. ಗಿರೀಶ್ ಸಿ.ಹೊಸೂರು, ಐಎಫ್ಎಸ್",
    [NAME15_L2]: "ಮಹಾನಗರ ಪಾಲಿಕೆ ಆಯುಕ್ತ ಬಿಎಂಆರ್‌ಡಿಎ",
    [NAME15_L3]: "ಕರ್ನಾಟಕ ಸರ್ಕಾರ, ನಂ.1, ಅಲಿ ಆಸ್ಕರ್ ರಸ್ತೆ,",
    [NAME15_L4]: "ಬೆಂಗಳೂರು-560001.",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
